import React from 'react';
import { Box, Typography } from '@mui/material';

function Page1SubPageB3() {
  return (
    <Box p={4}>
      <Typography variant="h4">Proposals</Typography>
    </Box>
  );
}

export default Page1SubPageB3;
